module.exports = __webpack_public_path__ + "img/report3-1.65dc931c.jpg";